import React from 'react';
import NavContainer from "./components/Nav";
import OffCanvasNav from './components/OffCanvasNav';
import Dashboard from './components/DashBoard';
import { Helmet } from 'react-helmet';
import { useAuth } from './context/AuthContext';
import Customer from './components/Customer';



const App = () => {
  const { rol } = useAuth();
  console.log(rol);




  return (
    <>
      <NavContainer></NavContainer>
      <OffCanvasNav></OffCanvasNav>
      <Helmet><title>
        Inicio
      </title></Helmet>
      {rol == 1 &&
        <>
          <Dashboard></Dashboard>
        </>}
      {rol == 2 && <Customer></Customer>}
    </>
  );
}

export default App;